
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import type { WalletType } from '@/checkout/helpers/wallets'
import StripeWalletPayment from '@/checkout/stripe/StripeWalletPayment'
import type { PaymentMethodName } from '@/checkout/stripe/helpers'
import MobileCartButton from '@/components/elements/MobileCartButton.vue'
import Price from '@/components/elements/Price.vue'
import type { PayButtonContext } from '@/helpers/CartHelpers'
import { onSubmit } from '@/helpers/CartHelpers'
import { closeCartModal } from '@/modals/cartModal'

import PayButton from './PayButton.vue'

@Component({
  components: { MobileCartButton, Price, PayButton },
  computed: mapGetters({
    paymentDueByCreditCard: 'Cart/paymentDueByCreditCard',
  }),
})
export default class CheckoutMobileFooter extends Vue {
  @Prop()
  context: PayButtonContext

  @Prop({ default: false })
  submitDisabled: boolean

  @Prop({ default: false })
  submitting: boolean

  @Prop()
  supportedWallet: WalletType

  @Prop()
  selectedPaymentType: PaymentMethodName

  @Prop()
  wallet: StripeWalletPayment | null

  get hideCartAndTotal() {
    return this.$store.state.Cart.redeemMembership && this.$store.getters['Cart/paymentDueByCreditCard'] === 0
  }

  onSubmit() {
    closeCartModal()
    onSubmit(this.context, this.$router, () => this.$emit('submit'))
  }
}
